import React from 'react';

const TimelineTransferCaseIcon = (props) => {
    return (
        <svg width="16px" height="13px" viewBox="0 0 16 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
            <title>Shape</title>
            <desc>Created with Sketch.</desc>
            <g id="Symbols" stroke="none" stroke-width="1" fill={props.fill} fill-rule="evenodd">
                <g id="Timeline-Card-/-Icon-/-Transfer-Purple" transform="translate(0.000000, -2.000000)" fill="#262aff" fill-rule="nonzero">
                    <g id="forward-regular" transform="translate(0.000000, 2.285714)">
                        <path d="M7.640625,5.24375 L1.640625,0.2625 C0.996875,-0.271875 0,0.175 0,1.03125 L0,11.03125 C0,11.8875 0.996875,12.3375 1.640625,11.8 L7.640625,6.78125 C8.11875,6.38125 8.11875,5.64375 7.640625,5.24375 Z M1.5,9.959375 L1.5,2.096875 L6.21875,6.015625 L1.5,9.959375 Z M15.640625,5.24375 L9.640625,0.2625 C8.996875,-0.271875 8,0.175 8,1.03125 L8,11.03125 C8,11.8875 8.996875,12.3375 9.640625,11.8 L15.640625,6.78125 C16.11875,6.38125 16.11875,5.64375 15.640625,5.24375 Z M9.5,9.959375 L9.5,2.096875 L14.21875,6.015625 L9.5,9.959375 Z" id="Shape"></path>
                    </g>
                </g>
            </g>
        </svg>);
};

export default TimelineTransferCaseIcon;